import useFirebaseData from "./useFirebaseData";
import type { GlassData } from "../types";

const useFirebaseGlassData = (glasstype: string) => {
  return useFirebaseData<GlassData>(glasstype ? `/glassdata/${glasstype}` : null);
};

export const useAllFirebaseGlassData = () => {
  return useFirebaseData<Record<string, GlassData>>("/glassdata/");
};

export default useFirebaseGlassData;
